import React, { ReactNode } from 'react';
import {
    styled,
    ThemeProvider as StyledThemeProvider,
    useTheme as RealUseTheme,
    css,
} from 'styled-components';
import { Theme } from './theme';
import { cloudcharge } from './cloudcharge';
import { GlobalStyle } from './global-style';

export const ThemeProvider: React.FC<{ children?: ReactNode; theme?: Theme }> = ({
    children,
    theme = cloudcharge,
}) => {
    return (
        <StyledThemeProvider theme={theme}>
            <GlobalStyle />
            {children}
        </StyledThemeProvider>
    );
};

export function useTheme(): Theme {
    const context = RealUseTheme();
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider.');
    }
    return context as Theme;
}

export const sstyled = styled;
export const cssFromLib = css;
